import { render, staticRenderFns } from "./UserLoginSettings.vue?vue&type=template&id=27e04bf9&scoped=true"
import script from "./UserLoginSettings.vue?vue&type=script&lang=js"
export * from "./UserLoginSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e04bf9",
  null
  
)

export default component.exports